import { createActionGroup, emptyProps } from '@ngrx/store';

import { ActionSource } from '../../state/action-sources';

export const UnsavedChangesBannerActions = createActionGroup({
    source: ActionSource.UNSAVED_CHANGES_BANNER,
    events: {
        'Save Changes Button Clicked': emptyProps(),
        'Discard Unsaved Changes Button Clicked': emptyProps(),
    },
});
